import { usePrevious } from '@hook/common/use-previous.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isString } from '@util/data/is-exist';

export const useAuthorized = () => {
  const { token, mfa, key } = useStoreSelector((state) => state.auth.data);
  const prevToken = usePrevious(token);

  const hasMfaKey = isString(key);

  return { token, prevToken, isAuthorized: isString(token), isNeedMfa: mfa && hasMfaKey, hasMfaKey };
};
